import { getSintegradaServerApi } from "@/services/api";
import { MedicalAttendanceFilterParams } from "@/@types/sintegrada/MedicalAttendanceFilterParams";
import { Paginated } from "@/@types/generics/paginated";
import { User } from "@/@types/sintegrada/User";
import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { Patient } from "@/@types/sintegrada/Patient";

export type MedicalAttendance = {
	attendanceEmergId: number;
	attendanceDate: string;
	firstAttendance: string;
	lastEvaluation: string;
	professional: User;
	riskClassification?: RiskClassification;
	patient: Patient;
};

export type MedicalAttendancePaginated = Paginated<MedicalAttendance>;

export async function getMedicalAttendances({
	uf,
	ibgeCode,
	cnes,
	...params
}: MedicalAttendanceFilterParams) {
	const url = `/attendance/medical-attendances`;

	const { data } = await getSintegradaServerApi().get<MedicalAttendancePaginated>(url, {
		ibgeCode,
		cnes,
		...params,
	});

	return data || ({} as MedicalAttendancePaginated);
}
